import { Node } from '@cast/types';

export const getResourceUsagePercentage = (
  request?: number,
  allocatable?: number
): number | undefined => {
  let value;
  if (allocatable && request !== undefined) {
    value = (request * 100) / allocatable;
  }

  return value;
};

export const getNodeRegion = (node?: Node): string | undefined => {
  return node?.labels?.['topology.kubernetes.io/region'];
};

export const isEdgeNode = (node?: Node): boolean => {
  return !!node?.labels?.['omni.cast.ai/edge-id'];
};
